var map = {
	"./info-sharing-accounts-de.html": 1035,
	"./info-sharing-accounts-en.html": 1036,
	"./info-sharing-accounts-es.html": 1037,
	"./info-sharing-accounts-fr.html": 1038,
	"./info-sharing-accounts-ja.html": 1039,
	"./info-sharing-accounts-pt.html": 1040,
	"./info-sharing-accounts-zh.html": 1041
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1034;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts ^\.\/info\-sharing\-accounts\-.*\.html$
// module id = 1034
// module chunks = 0